/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CompanyTimelineFromJSON, CompanyTimelineToJSON } from './CompanyTimeline';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function CompanyTimelinesResponseDataFromJSON(json) {
    return CompanyTimelinesResponseDataFromJSONTyped(json, false);
}
export function CompanyTimelinesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyTimelines: !exists(json, 'company_timelines')
            ? undefined
            : json['company_timelines'].map(CompanyTimelineFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function CompanyTimelinesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_timelines: value.companyTimelines === undefined
            ? undefined
            : value.companyTimelines.map(CompanyTimelineToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
